module.exports = __webpack_public_path__ + "img/9791195445301.84fb789b.jpg";